import { howSupportWorks } from "../../../mocks/home";

export default function HowSupportWorks() {
  return (
    <section className="w-full bg-background-50 py-12 md:py-20">
      <div className="w-full px-4 sm:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-foreground-950 mb-4">
              How I&rsquo;ll Support You, The Secret Evening Drinker And What I Offer&hellip;
            </h2>
            <div className="font-body text-sm md:text-base text-foreground-600 max-w-3xl mx-auto space-y-3">
              <p>
                A private, compassionate, step-by-step approach designed to help you understand your relationship with alcohol, build greater self-awareness, and create meaningful, lasting change&mdash;at your own pace and without judgement.
              </p>
              <p>
                I offer a free 1:1 discovery call to get you started in a discreet, private environment and a free PDF of your next steps guide.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 mb-10 md:mb-14">
            <div className="w-full md:w-3/5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 stagger-children">
                {howSupportWorks.map((item) => (
                  <div
                    key={item.step}
                    className="bg-background-100 rounded-lg p-6 md:p-7 border border-background-200/50 hover:border-primary-200/50 transition-all duration-500"
                  >
                    <span className="inline-block font-heading text-2xl md:text-3xl font-light text-primary-500 mb-4">
                      {item.step}.
                    </span>
                    <h3 className="font-heading text-lg md:text-xl font-medium text-foreground-900 mb-3">
                      {item.title}
                    </h3>
                    <p className="font-body text-sm text-foreground-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full md:w-2/5">
              <div className="relative overflow-hidden rounded-lg h-[260px] md:h-[320px]">
                <img
                  src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/df335f699e9f61bda7803626e38b2b52.png"
                  alt="A cosy home desk workspace with laptop, notebook, tea, and a soft warm lamp, calm and private atmosphere"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}